module.exports = __webpack_public_path__ + "img/06.87cc7e12.jpg";